import { ImageUrlWidget } from './views/administration/apps-config/json-schema-form/custom-widgets/image-url.widget';
import { KvJsonFormSchemaComponent } from './views/administration/apps-config/json-schema-form/kv-json-form-schema.component';
import { ImageUploadWidget } from './views/administration/apps-config/json-schema-form/custom-widgets/image-upload.widget';
import { AssociationMsbaseurlFormComponent } from './views/administration/associations-management/associations/association-msbaseurl-form/association-msbaseurl-form.component';
import { AssociationsManagementComponent } from './views/administration/associations-management/associations-management.component';
import { AssociationDatesFormComponent } from './views/administration/associations-management/associations/association-dates-form/association-dates-form.component';
import { UserStoresAndSalesNetworksComponent } from './views/administration/company-admin/user-stores-and-sales-networks/user-stores-and-sales-networks.component';
import { StoreSelectionTableComponent } from './views/administration/store/store-group/store-selection-table/store-selection-table.component';
import { FamilyCardComponent } from './views/customerDB/customers/family-card/family-card.component';
import { ValidationMsgComponent } from './modules/UIKit/components/validation-msg/validation-msg.component';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { DIRECTIVES, PIPES, VALIDATORS, VIEWS } from './views';
import { BASE_MODULES, MODULES } from './modules';
import { SERVICES } from './services';
import { registerLocaleData } from '@angular/common';
import locale from '@angular/common/locales/it';
import { AlgoritmoRiletturaComponent } from './views/administration/algoritmo-rilettura/algoritmo-rilettura.component';
import { LoyaltyCardHomingComponent } from './views/loyalty/loyalty-card-homing/loyalty-card-homing.component';
import { LimitInputNum } from './views/campaign/new-campaign/step-3/triple-percentage-slider/limitInputNum.directive';
import { HtmlEditorWidget } from './views/administration/apps-config/json-schema-form/custom-widgets/html.widget';
import { GoBackButtonComponent } from './views/campaign/new-campaign/go-back-button/go-back-button.component';
import { DragAndDropListComponent } from './views/campaign/new-campaign/step-2/drag-and-drop-list/drag-and-drop-list.component';
import { TriplePercentageSliderComponent } from './views/campaign/new-campaign/step-3/triple-percentage-slider/triple-percentage-slider.component';
import { CouponsSlidersComponent } from './views/campaign/new-campaign/step-4/coupons/coupons-sliders/coupons-sliders.component';
import { CouponSlider1Component } from './views/campaign/new-campaign/step-4/coupons/coupons-sliders/coupon-slider-1/coupon-slider-1.component';
import { CouponSlider2Component } from './views/campaign/new-campaign/step-4/coupons/coupons-sliders/coupon-slider-2/coupon-slider-2.component';
import { CouponSlider3Component } from './views/campaign/new-campaign/step-4/coupons/coupons-sliders/coupon-slider-3/coupon-slider-3.component';
import { CategoryCouponsSliderComponent } from './views/campaign/new-campaign/step-4/coupons/category-coupons-slider/category-coupons-slider.component';
import { CategoryCouponSlider1Component } from './views/campaign/new-campaign/step-4/coupons/category-coupons-slider/category-coupon-slider-1/category-coupon-slider-1.component';
import { CategoryCouponSlider2Component } from './views/campaign/new-campaign/step-4/coupons/category-coupons-slider/category-coupon-slider-2/category-coupon-slider-2.component';
import { CategoryCouponSlider3Component } from './views/campaign/new-campaign/step-4/coupons/category-coupons-slider/category-coupon-slider-3/category-coupon-slider-3.component';
import { CardSelectionTableComponent } from './views/customerDB/widget/customer-card-search/card-selection-table/card-selection-table.component';
import { LoyaltyCardHomingFormComponent } from './views/loyalty/loyalty-card-homing/loyalty-card-homing-form/loyalty-card-homing-form.component';
import { ExternalViewComponent } from './views/external-view/external-view.component';
import { ChartModule } from 'angular2-highcharts';
import { ChartModule as PrimeChartModule } from 'primeng/chart';
import { HighchartsStatic } from 'angular2-highcharts/dist/HighchartsService';
import { UserPswResetFormComponent } from './views/administration/company-admin/user-psw-reset-form/user-psw-reset-form.component';
import { UserAppRoleManagementComponent } from './views/administration/company-admin/user-app-role-management/user-app-role-management.component';
import { HttpClientModule } from '@angular/common/http';
import { SchemaFormModule, WidgetRegistry } from "ngx-schema-form";

/* Json Schema Form and Custom Widgets */
import { JsonSchemaFormComponent } from './views/administration/apps-config/json-schema-form/json-schema-form.component';
import { WidgetRegistryPrimeNG } from './views/administration/apps-config/json-schema-form/custom-widgets/WidgetRegistryPrimeNG';
import { InputWidget } from './views/administration/apps-config/json-schema-form/custom-widgets/input.widget';
import { SelectWidget } from './views/administration/apps-config/json-schema-form/custom-widgets/select.widget';
import { RadioWidget } from './views/administration/apps-config/json-schema-form/custom-widgets/radio.widget';
import { CheckboxWidget } from './views/administration/apps-config/json-schema-form/custom-widgets/checkbox.widget';
import { NumberWidget } from './views/administration/apps-config/json-schema-form/custom-widgets/number.widget';
import { TextareaWidget } from './views/administration/apps-config/json-schema-form/custom-widgets/textarea.widget';
import { CalendarWidget } from './views/administration/apps-config/json-schema-form/custom-widgets/calendar.widget';
import { LoyaltyReservationGiftStatusFormComponent } from './views/loyalty/loyalty-reservation-gift-status/loyalty-reservation-gift-status-form/loyalty-reservation-gift-status-form.component';
import { LoyaltyReservationSearchComponent } from './views/loyalty/loyalty-reservation-search/loyalty-reservation-search.component';
import { CronJobsModule } from 'ngx-cron-jobs';
import { CustomerSetImportComponent } from './views/customerDB/customer-set-import/customer-set-import.component';
import { CustomerSetImportAddComponent } from './views/customerDB/customer-set-import/customer-set-import-add/customer-set-import-add.component';
import { LoyaltyCatalogCategoryComponent } from './views/loyalty/loyalty-catalog-category/loyalty-catalog-category.component';
import { LoyaltyCatalogCategoryFormComponent } from './views/loyalty/loyalty-catalog-category/loyalty-catalog-category-form/loyalty-catalog-category-form.component';
import { CampaignActionSetupComponent } from './views/campaign-2.0/campaign-action-setup/campaign-action-setup.component';
import { ExtClusterAnalyticsComponent } from './views/customerDB/customers/ext-cluster-analytics/ext-cluster-analytics.component';
import { CampaignBreadcrumbComponent } from './views/campaign-2.0/campaign-breadcrumb/campaign-breadcrumb.component';
import { ImportGiftRowsDetailComponent } from './views/loyalty/loyalty-import-gift/import-gift-rows-detail/import-gift-rows-detail.component';
import { ReportUserComponent } from './views/administration/report-user/report-user.component';
import { ViewReportComponent } from './views/administration/report-user/view-report/view-report.component';
import { ReportCompanyAppComponent } from './views/administration/report-user/report-company-app/report-company-app.component';
import { ReportUserCompanyAppComponent } from './views/administration/report-user/report-user-company-app/report-user-company-app.component';
import { ReportUserRolesComponent } from './views/administration/report-user/report-user-roles/report-user-roles.component';
import { ReportRolesPermissionComponent } from './views/administration/report-user/report-roles-permission/report-roles-permission.component';
import { RolesManagementComponent } from './views/administration/roles-management/roles-management.component';
import { RolesCreationComponent } from './views/administration/roles-creation/roles-creation.component';
import { AssociationsComponent } from './views/administration/associations-management/associations/associations.component';
import { CampaignDragAndDropComponent } from './views/campaign-2.0/campaign-drag-and-drop/campaign-drag-and-drop.component';
import { CouponManagerComponent } from './views/customerDB/customers/coupon-manager/coupon-manager.component';
import { CouponHistoryComponent } from './views/customerDB/customers/coupon-manager/coupon-history/coupon-history.component';
import { CouponValidityComponent } from './views/campaign-2.0/coupon-fruition-setup/coupon-validity/coupon-validity.component';
import { DsnOperationMailComponent } from './views/administration/dsn-operation-mail/dsn-operation-mail.component';
import { DsnOperationMailFormComponent } from './views/administration/dsn-operation-mail/dsn-operation-mail-form/dsn-operation-mail-form.component';
import { StoreAutocompleteComponent } from './views/store/store-autocomplete/store-autocomplete.component';
import { Campaign3BreadcrumbComponent } from './views/campaign-3/components/campaign-3-breadcrumb/campaign-3-breadcrumb.component';
import { FormFields } from './views/campaign-3/components/form-fields/form-fields.component';
import { PhasesToolbarComponent } from './views/campaign-3/components/phases-toolbar/phases-toolbar.component';
import { CustomerOblivionComponent } from './views/customerDB/customer-oblivion/customer-oblivion.component';
import { CKEditorModule } from 'ckeditor4-angular';
import { FormsModule } from '@angular/forms';
import { EditorModule } from 'primeng/primeng';
import { CatalogoPremiComponent } from './views/customerDB/customers/catalogo-premi/catalogo-premi.component';
import { RulesComponent } from './views/audit/rules/rules.component';
import { EventsComponent } from './views/audit/events/events.component';
import { RulesAppliedComponent } from './views/audit/rulesapplied/rulesapplied.component';
import { AddRuleComponent } from './views/audit/rules/add-rule/add-rule.component';
import { FormlyModule } from '@ngx-formly/core';
import { FormlyPrimeNGModule } from '@ngx-formly/primeng';
import { PanelWrapperComponent } from './views/challenge/panel-wrapper/panel-wrapper.component';
import { FormlyFieldFile } from './shared/components/schema-form/file-type-formly/file-type.component';
import { QuillModule } from 'ngx-quill';
import { FormlyFieldQuillComponent } from './shared/components/schema-form/formly-field-quill/formly-field-quill.component';
import { SchemaFormComponent } from './shared/components/schema-form/schema-form.component';


registerLocaleData(locale, 'it');


export function highchartsFactory() {
  const h1 = require('highcharts');
  const h2 = require('highcharts/highcharts-more');
  const h3 = require('highcharts/modules/sankey');
  const h4 = require('highcharts/modules/heatmap');
  const dd = require('highcharts/modules/exporting');
  h2(h1);
  h3(h1);
  h4(h1);
  dd(h1);
  return h1;
}

@NgModule({
  declarations: [
    PanelWrapperComponent,
    AppComponent,
    ...VIEWS,
    ...VALIDATORS,
    ...DIRECTIVES,
    ...PIPES,

    ValidationMsgComponent,
    AlgoritmoRiletturaComponent,
    LoyaltyCardHomingComponent,
    GoBackButtonComponent,
    DragAndDropListComponent,
    TriplePercentageSliderComponent,
    LimitInputNum,
    CouponsSlidersComponent,
    CouponSlider1Component,
    CouponSlider2Component,
    CouponSlider3Component,
    CategoryCouponsSliderComponent,
    CategoryCouponSlider1Component,
    CategoryCouponSlider2Component,
    CategoryCouponSlider3Component,
    CardSelectionTableComponent,
    LoyaltyCardHomingFormComponent,
    ExternalViewComponent,
    UserPswResetFormComponent,
    UserAppRoleManagementComponent,
    UserStoresAndSalesNetworksComponent,
    FamilyCardComponent,
    StoreSelectionTableComponent,
    JsonSchemaFormComponent,
    KvJsonFormSchemaComponent,
    InputWidget,
    SelectWidget,
    RadioWidget,
    CheckboxWidget,
    NumberWidget,
    TextareaWidget,
    CalendarWidget,
    HtmlEditorWidget,
    ImageUploadWidget,
    ImageUrlWidget,
    LoyaltyReservationGiftStatusFormComponent,
    LoyaltyReservationSearchComponent,
    CustomerSetImportComponent,
    CustomerSetImportAddComponent,
    LoyaltyCatalogCategoryComponent,
    LoyaltyCatalogCategoryFormComponent,
    CampaignActionSetupComponent,
    ExtClusterAnalyticsComponent,
    CampaignBreadcrumbComponent,
    ImportGiftRowsDetailComponent,
    AssociationsComponent,
    ReportUserComponent,
    ViewReportComponent,
    ReportCompanyAppComponent,
    ReportUserCompanyAppComponent,
    ReportUserRolesComponent,
    ReportRolesPermissionComponent,
    AssociationsComponent,
    AssociationsManagementComponent,
    AssociationDatesFormComponent,
    RolesManagementComponent,
    RolesCreationComponent,
    AssociationMsbaseurlFormComponent,
    CampaignDragAndDropComponent,
    CouponManagerComponent,
    CouponHistoryComponent,
    CouponValidityComponent,
    DsnOperationMailComponent,
    DsnOperationMailFormComponent,
    StoreAutocompleteComponent,
    CatalogoPremiComponent,
    FormlyFieldFile,
    FormlyFieldQuillComponent,

    //CAMPAIGN 3
    FormFields,
    Campaign3BreadcrumbComponent,
    PhasesToolbarComponent,
    RulesComponent,
    EventsComponent,
    RulesAppliedComponent,
    AddRuleComponent,
    CustomerOblivionComponent,
    SchemaFormComponent,

  ],
  imports: [

    PrimeChartModule,
    ChartModule,
    HttpClientModule,
    SchemaFormModule.forRoot(),
    CronJobsModule,
    FormsModule,
    EditorModule,
    CKEditorModule,
    QuillModule,
    FormlyModule.forRoot({
      wrappers: [
        {
          name: 'panel',
          component: PanelWrapperComponent
        }
      ],
      types: [
        // eventuali custom types qui
        { name: 'file', component: FormlyFieldFile, wrappers: ['form-field'] },
        { name: 'html-quill', component: FormlyFieldQuillComponent, wrappers: ['form-field']}
      ]
    }),
    FormlyPrimeNGModule,
    ...MODULES,

  ],
  providers: [
    {
      provide: HighchartsStatic,
      useFactory: highchartsFactory
    },
    { provide: WidgetRegistry, useClass: WidgetRegistryPrimeNG },
    ...SERVICES
  ],
  exports: [
    ...BASE_MODULES
  ],
  entryComponents: [
    ...VIEWS,
    InputWidget,
    SelectWidget,
    RadioWidget,
    CheckboxWidget,
    NumberWidget,
    TextareaWidget,
    CalendarWidget,
    ImageUploadWidget,
    ImageUrlWidget,
    HtmlEditorWidget,
    FormlyFieldFile
  ],
  bootstrap: [
    AppComponent
  ]
})

export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts